//components
import { PillLink } from '@/containers-ai/Buttons';
import { Grad } from '@/containers-ai/SectionHeading';
import { PlatformScale, platformScaleStats } from '@/containers-ai/PlatformScale';
import { HeroVisual } from './HeroVisual';

//styles
import {
  HeroSection,
  HeroInner,
  HeroTop,
  HeroCopy,
  Eyebrow,
  HeroTitle,
  HeroSub,
  CtaRow,
  HeroImageWrap,
} from './Hero.styles';

export function Hero() {
  return (
    <HeroSection id="top">
      <HeroInner>
        <HeroTop>
          <HeroCopy>
            <Eyebrow>THE AUTONOMOUS TRANSPORTATION EXECUTION PLATFORM</Eyebrow>
            <HeroTitle>
              One connected platform.
              <br />
              <Grad>Run by AI.</Grad>
            </HeroTitle>
            <HeroSub>
              One platform &mdash; the AI-native TMS and the industry&rsquo;s
              leading dock scheduling, gate and yard network &mdash; runs
              your complete freight lifecycle.
            </HeroSub>
            <HeroSub>
              <b>Loadsmart AI does the work</b> and writes every outcome back
              into your system of record. When freight throws an exception,{' '}
              <b>our Freight Experts take care of it.</b>
            </HeroSub>
            <CtaRow>
              <PillLink href="#platform">
                Discover the Platform &#8594;
              </PillLink>
            </CtaRow>
          </HeroCopy>

          <HeroImageWrap>
            <HeroVisual />
          </HeroImageWrap>
        </HeroTop>

        <PlatformScale stats={platformScaleStats} />
      </HeroInner>
    </HeroSection>
  );
}
